import type { TocEntry } from '../../utils/articleToc';
import { getTocDisplayEntries, shouldShowAutoToc } from '../../utils/articleToc';

interface ArticleTableOfContentsProps {
  entries: TocEntry[];
}

export default function ArticleTableOfContents({ entries }: ArticleTableOfContentsProps) {
  const displayEntries = getTocDisplayEntries(entries);

  if (!shouldShowAutoToc(displayEntries)) {
    return null;
  }

  return (
    <nav className="article-toc" aria-label="目次">
      <h2 className="article-toc__title">目次</h2>
      <ol className="article-toc__list">
        {displayEntries.map((entry) => (
          <li key={entry.id} className="article-toc__item">
            <a className="article-toc__link article-toc__link--h2" href={`#${entry.id}`}>
              {entry.text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
